import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Pagination, Typography } from "antd";
import { journalsQueries } from "@/entities/journal";
import { useCoordinator } from "@/shared/lib/hooks";
import { ObjectJournalsElement } from "../object-journals-element";
import { ObjectJournalsListSkeleton } from "../object-journals-list-skeleton";
import "./object-journals-list.scss";

export const ObjectJournalsList = () => {
  const { objectId } = useCoordinator();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const { data, error, isLoading } = useQuery(
    journalsQueries.getDraftJournals({
      buildingObjectId: objectId,
      page,
      limit: pageSize,
    }),
  );

  if (isLoading) {
    return <ObjectJournalsListSkeleton />;
  }

  if (error) {
    return (
      <Typography.Text
        type="secondary"
        style={{ fontSize: "16px", lineHeight: "24px" }}
      >
        Журналов не найдено
      </Typography.Text>
    );
  }

  const total = data?.total || 0;

  return (
    <div className="object-journals-list">
      {data?.buildingObject?.mainJournals?.length ? (
        <>
          {data.buildingObject.mainJournals.map((item, index) => (
            <ObjectJournalsElement
              key={item.mainJournalId}
              journalInfo={item}
              address={data.buildingObject.address.addressString}
              defaultOpen={index === 0}
              isV2
            />
          ))}

          <Pagination
            current={page}
            pageSize={pageSize}
            total={total}
            showSizeChanger
            onChange={(newPage, newPageSize) => {
              setPage(newPage);
              setPageSize(newPageSize);
            }}
          />
        </>
      ) : (
        <div className="object-journals-list__empty">У объекта нету журналов</div>
      )}
    </div>
  );
};
